import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlan } from 'State/Plans/PlansActions';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { LinkSubmitButton } from 'Components/Fields/Buttons';
import { getPlanButtonText } from 'Utils/Plans';

export const PlanLink = ({ className, plan, ctaText, modernStyle, isDisabled = false }) => {
  const dispatch = useDispatch();
  const { planId, planName, hasMerchandise, planPrice } = plan;
  const { isAuthenticated } = useSelector((s) => s.user);
  const routes = useSelector((s) => s.appConfig.routes);
  const { hasSubscription } = useSelector((s) => s.subscription);

  const text = getPlanButtonText(hasSubscription, plan, ctaText);

  const handleClick = async () => {
    trackEvent(TRACKING_ENUMS.EVENT_PLAN_SELECT_COMPLETE, {
      page_plan_name: planName,
      page_plan_price: planPrice,
      page_plan_id: planId,
    });
    await dispatch(selectPlan(planId));
  };

  // default to sign up link
  let path = routes.signupCreateAccount;
  if (isAuthenticated) {
    path = routes.payment;
    if (hasMerchandise) {
      path = routes.shipping;
    }
  }
  return (
    <LinkSubmitButton
      modernStyle={modernStyle}
      className={className}
      path={path}
      onClick={handleClick}
      text={text}
      isDisabled={isDisabled}
    />
  );
};
